import { IntegrationActions } from './actions'
import { IntegrationGetters } from './getters'
import { IntegrationMutations } from './mutations'
import { IntegrationState } from './state'

export const INTEGRATION_NAMESPACE = 'integrations'

export const Integrations = {
  namespaced: true,
  state: IntegrationState,
  actions: IntegrationActions,
  mutations: IntegrationMutations,
  getters: IntegrationGetters,
}
